import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Button, Fade, Menu, MenuItem, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useState } from "react";

const useStyles = makeStyles(({ palette }) => ({
  feeButton: {
    paddingLeft: 0,
    paddingRight: 0,
    "&:hover": {
      backgroundColor: "inherit",
    },
    "& .MuiButton-endIcon": {
      marginLeft: 0,
    },
  },
  feeTextField: {
    height: 28,
    width: 52,

    "& .MuiOutlinedInput-input": {
      fontSize: 16,
      paddingLeft: 8,
      paddingRight: 0,
    },

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: palette.secondary.dark,
    },
  },
}));

interface SelectProps {
  label?: string;
  options?: string[];
  onSave: (option: any) => any;
  defaultSelected: string;
}

export const Select: React.FC<SelectProps> = ({
  label,
  onSave,
  options,
  defaultSelected,
}) => {
  const styles = useStyles();
  const [selectedOption, setSelectedOption] = useState<string>(defaultSelected);
  // eslint-disable-next-line no-undef
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const popoverOpen = Boolean(anchorEl);

  const onClosePopover = () => {
    setAnchorEl(null);
  };

  const onOptionClick = (option: string) => {
    setSelectedOption(option);
    onSave(option);
    onClosePopover();
  };

  return (
    <Box alignItems="center" display="flex">
      <Button
        className={styles.feeButton}
        endIcon={popoverOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        size="small"
        variant="text"
        disableRipple
      >
        <Box display="flex" alignItems="baseline">
          <Typography variant="subtitle2">
            <span
              style={{
                fontWeight: "bold",
              }}
            >
              {label}:{" "}
            </span>
          </Typography>
          <Box
            style={{
              color: "white",
              fontSize: 18,
            }}
            px={2}
          >
            {selectedOption}
          </Box>
        </Box>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={popoverOpen}
        TransitionComponent={Fade}
        // getContentAnchorEl={null}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={onClosePopover}
      >
        {options?.map((option) => (
          <MenuItem
            key={option}
            selected={defaultSelected === option}
            value={option}
            onClick={() => {
              onOptionClick(option);
            }}
            data-cy={`menu-item-${option.toLowerCase()}`}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
